export const CountInput = {
	selectors: {
		countInputSelector: Array.prototype.slice.call(document.querySelectorAll('.js-count-input')),
		plusSelector: '.js-count-input--plus',
		minusSelector: '.js-count-input--minus',
		inputSelector: '.js-count-input--input',
	},

	init: function() {
		let self = this;

		if (self.selectors.countInputSelector) {
			self.selectors.countInputSelector.forEach((x) => {
				self.countingEvents(x);
			});
		}
	},

	countingEvents: function(_selector) {
		let self = this;
		let el = _selector;
		let plusSelector = el.querySelector(self.selectors.plusSelector);
		let minusSelector = el.querySelector(self.selectors.minusSelector);
		let inputSelector = el.querySelector(self.selectors.inputSelector);
		let inputValue = inputSelector.value === '' ? 0 : Number(inputSelector.value);

		let step = Number(inputSelector.getAttribute('step'));

		plusSelector.addEventListener('click', function(event) {
			event.preventDefault();

			let max = Number(inputSelector.getAttribute('max'));
			let inputValue = inputSelector.value === '' ? 0 : Number(inputSelector.value);

			if (inputValue === max) {
				inputValue = max;
			} else {
				inputValue += step;
			}

			self.setInput(inputSelector, inputValue);
			inputSelector.dispatchEvent(new CustomEvent('change'));
		});

		minusSelector.addEventListener('click', function(event) {
			event.preventDefault();

			let min = Number(inputSelector.getAttribute('min'));
			let inputValue = inputSelector.value === '' ? 0 : Number(inputSelector.value);

			if (inputValue === min) {
				inputValue = min;
			} else {
				inputValue -= step;
			}

			self.setInput(inputSelector, inputValue);
			inputSelector.dispatchEvent(new CustomEvent('change'));
		});

		inputSelector.addEventListener('input', function(event) {
			event.preventDefault();
			let thisValue = Number(this.value);

			let min = Number(inputSelector.getAttribute('min'));
			let max = Number(inputSelector.getAttribute('max'));

			if (thisValue >= max) {
				inputValue = max;
			} else if (thisValue <= min) {
				inputValue = min;
			} else {
				inputValue = thisValue;
			}

			self.setInput(inputSelector, inputValue);
		});
	},

	setInput: function(_selector, _number) {
		let newValue = _number;
		let min = Number(_selector.getAttribute('min'));
		let max = Number(_selector.getAttribute('max'));

		_selector.value = newValue;

		if (_selector.value > max) {
			_selector.value = max;
		} else if (_selector.value < 0) {
			_selector.value = min;
		}
	}
};

CountInput.init();

